<template>
    <div is="markdown"></div>
</template>

<script>
export default {
  name: 'MarkdownHtml'
}
</script>
